var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="'+
((__t=( url ))==null?'':_.escape(__t))+
'" class="link">\n  <div class="flag__image">\n    <div class="avatar avatar--S"></div>\n  </div>\n  <div class="user__data flag__body">\n      '+
((__t=( name ))==null?'':_.escape(__t))+
'\n  </div>\n</a>\n';
}
return __p;
};
